import React, { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { athletedetail, studentview, teacherview, workerdetail, workerdashboardcount, updateprofilephoto } from "../service/dashboard";
import Footer from "./footer";
import Header from "./header";
import moment from "moment";
import { toast } from "react-toastify";

const MyProfile = () => {
  const [sdetail, setSDetail] = useState({});
  const [hdetail, setHDetail] = useState({});
  const [tdetail, setTDetail] = useState(null); // worker/driver vehicle (transport)

  const [spath, setSPath] = useState("");
  const [qrpath, setQRPath] = useState("");

  const role = localStorage.getItem("Role");
  // Worker (6) and Driver (9) share the workers table / worker profile API.
  const isWorker = role === "6" || role === "9";
  // Worker photo lives in a different column than student/teacher
  const photoField = isWorker ? "worker_photo" : "photo";

  const [photoFile, setPhotoFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploading, setUploading] = useState(false);

  function loaddetail() {
    if (role === "4") {
      studentview(localStorage.getItem("UID")).then((res) => {
        if (res.status === true) {
          setSDetail(res.data.details);
          setHDetail(res.data.hostel);
          setSPath(res.data.path);
          setQRPath(res.data.qrpath);
        }
      });
    } else if (role === "5") {
      teacherview(localStorage.getItem("UID")).then((res) => {
        if (res.status === true) {
          setSDetail(res.data.details);
          setHDetail(res.data.hostel);
          setSPath(res.data.path);
          setQRPath(res.data.qrpath);
        }
      })
    } else if (isWorker) {
      // The app knows the user_id; resolve it to the workers.id first, then
      // load the full worker profile from the same API the web profile uses.
      const temp = new FormData();
      temp.append("user_id", localStorage.getItem("UID"));
      temp.append("role_id", role);
      workerdashboardcount(temp).then((wres) => {
        const workerId = wres?.status === true && wres.data.workers ? wres.data.workers.id : null;
        if (!workerId) return;
        workerdetail(workerId).then((res) => {
          if (res?.status === true) {
            setSDetail(res.data.details);
            setSPath(res.data.path);
            setQRPath(res.data.qrpath);
            setTDetail(res.data.transport);
          }
        });
      });
    }
  }

  useEffect(() => {
    loaddetail();
  }, [])

  function handlePhotoSelect(ev) {
    const file = ev.target.files[0];
    if (!file) return;
    setPhotoFile(file);
    setPreview(URL.createObjectURL(file));
  }

  function handlePhotoSubmit() {
    if (!photoFile) {
      toast.error("Please select a photo");
      return;
    }
    setUploading(true);
    const temp = new FormData();
    temp.append("user_id", localStorage.getItem("UID"));
    temp.append("role_id", role);
    temp.append("photo", photoFile);
    updateprofilephoto(temp).then((res) => {
      setUploading(false);
      if (res && res.status === true) {
        toast.success(res.message);
        setSDetail((prev) => ({ ...prev, [photoField]: res.data.photo }));
        if (res.data.path) setSPath(res.data.path);
        setPhotoFile(null);
        setPreview(null);
      } else {
        toast.error(res?.message || "Failed to update photo");
      }
    });
  }

  function errorhandle(ev) {
    ev.target.src = require("../assets/images/placeholder.png");
    ev.target.onerror = null;
  }

  return (
    <div id="mainpage">
      <div className="maincontent">
        <Header />

        <div className="moreone inner">
          <div className="moreheading">
            <Row className="row-sm">
              <div className="col-7 pr-0 text-left align-self-end"></div>

              <div className="col-5 pl-0 text-right align-self-end">
                <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                  <i className="fa-solid fa-hand-point-left"></i> Go Back
                </Link>
              </div>
            </Row>
          </div>

          <div className="morecontent">
            <div className="morecontent-inner">
              <div style={{ position: "relative", display: "inline-block" }}>
                {preview ? (
                  <img src={preview} alt="profile-preview" className="profileimgg" />
                ) : sdetail?.[photoField] != null ? (
                  <img src={spath + sdetail?.[photoField]}
                    alt="profile-logo"
                    className="profileimgg"
                    onError={errorhandle}
                  />
                ) : (
                  <img
                    src={require("../assets/images/placeholder.png")}
                    alt="profile"
                    className="profileimgg"
                  />
                )}

                {!photoFile && (
                  <label
                    htmlFor="profilePhotoInput"
                    title="Edit Photo"
                    style={{
                      position: "absolute",
                      bottom: "6px",
                      right: "6px",
                      width: "32px",
                      height: "32px",
                      borderRadius: "50%",
                      background: "#198754",
                      color: "#fff",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                    }}
                  >
                    <i className="fa-solid fa-camera"></i>
                  </label>
                )}
                <input
                  id="profilePhotoInput"
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handlePhotoSelect}
                />

                {photoFile && (
                  <div
                    style={{
                      position: "absolute",
                      bottom: "6px",
                      right: "6px",
                      display: "flex",
                      gap: "8px",
                    }}
                  >
                    <button
                      type="button"
                      title="Submit"
                      onClick={handlePhotoSubmit}
                      disabled={uploading}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        background: "#198754",
                        color: "#fff",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                      }}
                    >
                      <i className={uploading ? "fa-solid fa-spinner fa-spin" : "fa-solid fa-check"}></i>
                    </button>
                    <button
                      type="button"
                      title="Cancel"
                      onClick={() => { setPhotoFile(null); setPreview(null); }}
                      disabled={uploading}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        background: "#dc3545",
                        color: "#fff",
                        border: "none",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        boxShadow: "0 1px 4px rgba(0,0,0,0.3)",
                      }}
                    >
                      <i className="fa-solid fa-xmark"></i>
                    </button>
                  </div>
                )}
              </div>
              {localStorage.getItem("Role") == 4 && (
                <h4 className="profname">{sdetail?.student_name}</h4>
              )}
              {localStorage.getItem("Role") == 5 && (
                <h4 className="profname">{sdetail?.teacher_name}</h4>
              )}
              {isWorker && (
                <h4 className="profname">{sdetail?.worker_name}</h4>
              )}
              {!isWorker && (
                <h3 className="profUID">{sdetail?.class_name} - {sdetail?.section_name}</h3>
              )}

              {/* <h3 className="profName"> {name} </h3> */}

              <div className="qrcodeimg">
                {sdetail?.qr_code != null && (
                  <img src={qrpath + sdetail?.qr_code} alt="qrcode" className="qrimg" />
                )}
                {sdetail?.qr_code == null && (
                  <img
                    src={require("../assets/images/qrcode.jpg")}
                    alt="qrcode"
                    className="qrimg"
                  />
                )}
              </div>

              <div className="morecontent-section mb-3">
                <h4>Personal Details</h4>
                <div className="traveldetails">
                  {localStorage.getItem("Role") == 4 && (
                    <h3 className="">
                      Name<span>: {sdetail?.student_name}</span>
                    </h3>
                  )}
                  {localStorage.getItem("Role") == 5 && (
                    <h3 className="">
                      Name<span>: {sdetail?.teacher_name}</span>
                    </h3>
                  )}
                  {isWorker && (
                    <h3 className="">
                      Name<span>: {sdetail?.worker_name}</span>
                    </h3>
                  )}

                  <h3 className="">
                    Gender<span>: {sdetail?.gender}</span>
                  </h3>
                  <h3 className="">
                    DOB<span>: {moment(sdetail?.date_of_birth).format("DD-MM-YYYY")}</span>
                  </h3>
                  <h3 className="">
                    Blood Group<span>: {sdetail?.blood_name}</span>
                  </h3>
                  <h3 className="">
                    Phone No<span>: {sdetail?.phone}</span>
                  </h3>
                  {localStorage.getItem("Role") == 4 && (
                    <>
                      <h3 className="">
                        EMIS No<span>: {sdetail?.emis_no}</span>
                      </h3>
                      <h3 className="">
                        Aadhar No<span>: {sdetail?.aadhar_no}</span>
                      </h3>
                    </>
                  )}

                  {localStorage.getItem("Role") == 5 && (
                    <>
                      <h3 className="">
                        Martial Status<span>: {sdetail?.marital_status}</span>
                      </h3>
                      <h3 className="">
                        Subject<span>: {sdetail?.subject_name}</span>
                      </h3>
                    </>
                  )}
                  {isWorker && (
                    <h3 className="">
                      Qualification<span>: {sdetail?.qualification}</span>
                    </h3>
                  )}
                </div>
              </div>
              <div className="morecontent-section mb-3">
                <h4>Academy Details</h4>
                <div className="traveldetails">
                  <h3 className="">
                    Unique Number<span>: {sdetail?.username}</span>
                  </h3>
                  {isWorker && (
                    <h3 className="">
                      Employee ID<span>: {sdetail?.employee_id}</span>
                    </h3>
                  )}
                  {localStorage.getItem("Role") == 4 && (
                    <>
                      <h3 className="">
                        Admission No<span>: {sdetail?.admission_number}</span>
                      </h3>
                      <h3 className="">
                        Roll No<span>: {sdetail?.roll_number}</span>
                      </h3>
                      <h3 className="">
                        Academic Year<span>: {sdetail?.aca_year}</span>
                      </h3>
                    </>
                  )}
                  {localStorage.getItem("Role") == 5 && (
                    <>
                      <h3 className="">
                        Staff Code<span>: {sdetail?.teacher_code}</span>
                      </h3>
                      <h3 className="">
                        Qualification<span>: {sdetail?.qual_name}</span>
                      </h3>
                      <h3 className="">
                        Department<span>: {sdetail?.department}</span>
                      </h3>
                      <h3 className="">
                        Designation<span>: {sdetail?.desi_name}</span>
                      </h3>
                      <h3 className="">
                        Reporting To<span>: {sdetail?.report_name}</span>
                      </h3>
                      <h3 className="">
                        Appointment<span>: {sdetail?.appoint_name}</span>
                      </h3>
                      <h3 className="">
                        Shift<span>: {sdetail?.shift_name}</span>
                      </h3>
                      <h3 className="">
                        Bank Name<span>: {sdetail?.bank_name}</span>
                      </h3>
                      <h3 className="">
                        Account No<span>: {sdetail?.bank_accno}</span>
                      </h3>
                    </>
                  )}

                  {!isWorker && (
                    <h3 className="">
                      Admission Date<span>: {moment(sdetail?.admission_date).format("DD-MM-YYYY")}</span>
                    </h3>
                  )}
                </div>
              </div>
              {!isWorker && (
                <div className="morecontent-section mb-3">
                  <h4>Parents Details</h4>
                  <div className="traveldetails">
                    <h3 className="">
                      Father Name<span>: {sdetail?.father_name}</span>
                    </h3>
                    <h3 className="">
                      Mother Name<span>: {sdetail?.mother_name}</span>
                    </h3>
                    {localStorage.getItem("Role") == 4 && (
                      <>
                        <h3 className="">
                          Guardian<span>: {sdetail?.guardian_name}</span>
                        </h3>
                        <h3 className="">
                          Email<span>: {sdetail?.parent_email}</span>
                        </h3>
                        <h3 className="">
                          Phone No<span>: {sdetail?.parent_phone}</span>
                        </h3>
                      </>
                    )}

                    <h3 className="">
                      Address<span>: {sdetail?.address1}</span>
                    </h3>
                  </div>
                </div>
              )}
              {isWorker && (
                <div className="morecontent-section mb-3">
                  <h4>Address Details</h4>
                  <div className="traveldetails">
                    <h3 className="">
                      Address<span>: {[sdetail?.address1, sdetail?.address2].filter(Boolean).join(", ")}</span>
                    </h3>
                    <h3 className="">
                      City<span>: {sdetail?.city}</span>
                    </h3>
                    <h3 className="">
                      District<span>: {sdetail?.district}</span>
                    </h3>
                    <h3 className="">
                      State<span>: {sdetail?.state_name}</span>
                    </h3>
                    <h3 className="">
                      Pin Code<span>: {sdetail?.pincode}</span>
                    </h3>
                  </div>
                </div>
              )}
              {(sdetail?.resident_type == 3 || sdetail?.teacher_resident == 3) &&
                <div className="morecontent-section mb-3">
                  <h4>Transport Details</h4>
                  <div className="traveldetails">
                    <h3 className="">
                      Vehicle Number<span>: {sdetail?.vehicle_no}</span>
                    </h3>
                    <h3 className="">
                      Driver<span>: {sdetail?.worker_name}</span>
                    </h3>
                    <h3 className="">
                      Vehicle Route<span>: {sdetail?.vehroute_name}</span>
                    </h3>
                    <h3 className="">
                      Mobile No<span>: {sdetail?.worker_phone}</span>
                    </h3>

                  </div>
                </div>

              }
              {isWorker && tdetail &&
                <div className="morecontent-section mb-3">
                  <h4>Transport Details</h4>
                  <div className="traveldetails">
                    <h3 className="">
                      Vehicle Number<span>: {tdetail?.vehicle_no}</span>
                    </h3>
                    <h3 className="">
                      Vehicle Type<span>: {tdetail?.vehtype_name}</span>
                    </h3>
                    <h3 className="">
                      Vehicle Route<span>: {tdetail?.vehroute_name}</span>
                    </h3>
                    <h3 className="">
                      Registration No<span>: {tdetail?.reg_no}</span>
                    </h3>
                  </div>
                </div>
              }
              {!isWorker && hdetail && hdetail.hostel_name &&
                <div className="morecontent-section mb-3">
                  <h4>Hostel Details</h4>
                  <div className="traveldetails">
                    {/* <h2 className="travelheading">Personal Details</h2> */}
                    <h3 className="">
                      Hostel<span>: {hdetail?.hostel_name}</span>
                    </h3>
                    <h3 className="">
                      Room No<span>: {hdetail?.room_no}</span>
                    </h3>
                    <h3 className="">
                      Warden<span>: {hdetail?.worker_name}</span>
                    </h3>
                    <h3 className="">
                      Admission date<span>: {moment(hdetail?.hostel_date).format("DD-MM-YYYY")}</span>
                    </h3>

                  </div>
                </div>
              }

              {/* <div className="prof-event pidcardtime text-center">
                <div className="prof-event-heading">Academy Details</div>
                <div className="prof-event-details">{acco}</div>
              </div> */}

              {/* <div className="text-danger text-center">
                * For any queries please contact your manager!
              </div> */}
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default MyProfile;
